export var CyberAssessmentStatus;
(function (CyberAssessmentStatus) {
    CyberAssessmentStatus["COMPLETE"] = "COMPLETE";
    CyberAssessmentStatus["DRAFT"] = "DRAFT";
})(CyberAssessmentStatus || (CyberAssessmentStatus = {}));
export var CyberAssessmentTrlBand;
(function (CyberAssessmentTrlBand) {
    CyberAssessmentTrlBand["TRL_1_3"] = "TRL_1_3";
    CyberAssessmentTrlBand["TRL_4_6"] = "TRL_4_6";
    CyberAssessmentTrlBand["TRL_7_9"] = "TRL_7_9";
})(CyberAssessmentTrlBand || (CyberAssessmentTrlBand = {}));
export var CyberAssessmentAukusClassificationGate;
(function (CyberAssessmentAukusClassificationGate) {
    CyberAssessmentAukusClassificationGate["SECRET_REL_AUKUS"] = "SECRET_REL_AUKUS";
    CyberAssessmentAukusClassificationGate["TOP_SECRET_REL_AUKUS"] = "TOP_SECRET_REL_AUKUS";
})(CyberAssessmentAukusClassificationGate || (CyberAssessmentAukusClassificationGate = {}));
export var CyberAssessmentAukusReadinessBand;
(function (CyberAssessmentAukusReadinessBand) {
    CyberAssessmentAukusReadinessBand["CONDITIONAL"] = "Conditional";
    CyberAssessmentAukusReadinessBand["NOT_READY"] = "Not Ready";
    CyberAssessmentAukusReadinessBand["PARTIAL"] = "Partial";
    CyberAssessmentAukusReadinessBand["READY"] = "Ready";
})(CyberAssessmentAukusReadinessBand || (CyberAssessmentAukusReadinessBand = {}));
export var CyberAssessmentBlockingType;
(function (CyberAssessmentBlockingType) {
    CyberAssessmentBlockingType["ANSWER_IN_PROGRESS"] = "ANSWER_IN_PROGRESS";
    CyberAssessmentBlockingType["ANSWER_NO"] = "ANSWER_NO";
    CyberAssessmentBlockingType["PHASE_DEPENDENCY"] = "PHASE_DEPENDENCY";
})(CyberAssessmentBlockingType || (CyberAssessmentBlockingType = {}));
export var CyberAssessmentClassificationCeiling;
(function (CyberAssessmentClassificationCeiling) {
    CyberAssessmentClassificationCeiling["CUI"] = "CUI";
    CyberAssessmentClassificationCeiling["OFFICIAL"] = "OFFICIAL";
    CyberAssessmentClassificationCeiling["OFFICIAL_SENSITIVE"] = "OFFICIAL-SENSITIVE";
    CyberAssessmentClassificationCeiling["PROTECTED"] = "PROTECTED";
    CyberAssessmentClassificationCeiling["SECRET"] = "SECRET";
    CyberAssessmentClassificationCeiling["TOP_SECRET"] = "TOP SECRET";
    CyberAssessmentClassificationCeiling["TS_SCI"] = "TS/SCI";
    CyberAssessmentClassificationCeiling["UNCLASSIFIED"] = "UNCLASSIFIED";
    CyberAssessmentClassificationCeiling["UNOFFICIAL"] = "UNOFFICIAL";
})(CyberAssessmentClassificationCeiling || (CyberAssessmentClassificationCeiling = {}));
export var CyberAssessmentCmmcPracticeStatus;
(function (CyberAssessmentCmmcPracticeStatus) {
    CyberAssessmentCmmcPracticeStatus["GAP_MAPPED"] = "GAP_MAPPED";
    CyberAssessmentCmmcPracticeStatus["MET"] = "MET";
    CyberAssessmentCmmcPracticeStatus["NOT_ASSESSED"] = "NOT_ASSESSED";
    CyberAssessmentCmmcPracticeStatus["NOT_MET"] = "NOT_MET";
    CyberAssessmentCmmcPracticeStatus["PARTIAL"] = "PARTIAL";
    CyberAssessmentCmmcPracticeStatus["PARTIAL_MAPPING"] = "PARTIAL_MAPPING";
})(CyberAssessmentCmmcPracticeStatus || (CyberAssessmentCmmcPracticeStatus = {}));
export var CyberAssessmentCpiBandLabel;
(function (CyberAssessmentCpiBandLabel) {
    CyberAssessmentCpiBandLabel["ASSURED"] = "Assured";
    CyberAssessmentCpiBandLabel["DEVELOPING"] = "Developing";
    CyberAssessmentCpiBandLabel["FOUNDATIONAL"] = "Foundational";
    CyberAssessmentCpiBandLabel["MATURE"] = "Mature";
    CyberAssessmentCpiBandLabel["NASCENT"] = "Nascent";
})(CyberAssessmentCpiBandLabel || (CyberAssessmentCpiBandLabel = {}));
export var CyberAssessmentDeploymentReadinessBand;
(function (CyberAssessmentDeploymentReadinessBand) {
    CyberAssessmentDeploymentReadinessBand["CLEARED"] = "Cleared";
    CyberAssessmentDeploymentReadinessBand["CONDITIONAL"] = "Conditional";
    CyberAssessmentDeploymentReadinessBand["EARLY"] = "Early";
    CyberAssessmentDeploymentReadinessBand["PROVISIONAL"] = "Provisional";
})(CyberAssessmentDeploymentReadinessBand || (CyberAssessmentDeploymentReadinessBand = {}));
export var CyberAssessmentPriority;
(function (CyberAssessmentPriority) {
    CyberAssessmentPriority["CRITICAL"] = "CRITICAL";
    CyberAssessmentPriority["HIGH"] = "HIGH";
    CyberAssessmentPriority["MEDIUM"] = "MEDIUM";
})(CyberAssessmentPriority || (CyberAssessmentPriority = {}));
export var CyberAssessmentRagStatus;
(function (CyberAssessmentRagStatus) {
    CyberAssessmentRagStatus["GREEN"] = "GREEN";
    CyberAssessmentRagStatus["RED"] = "RED";
    CyberAssessmentRagStatus["YELLOW"] = "YELLOW";
})(CyberAssessmentRagStatus || (CyberAssessmentRagStatus = {}));
export var CyberAssessmentRemediationEffort;
(function (CyberAssessmentRemediationEffort) {
    CyberAssessmentRemediationEffort["HIGH"] = "HIGH";
    CyberAssessmentRemediationEffort["LOW"] = "LOW";
    CyberAssessmentRemediationEffort["MEDIUM"] = "MEDIUM";
    CyberAssessmentRemediationEffort["VERY_HIGH"] = "VERY_HIGH";
})(CyberAssessmentRemediationEffort || (CyberAssessmentRemediationEffort = {}));
export var CyberAssessmentStigSeverity;
(function (CyberAssessmentStigSeverity) {
    CyberAssessmentStigSeverity["CAT_I"] = "CAT I";
    CyberAssessmentStigSeverity["CAT_II"] = "CAT II";
    CyberAssessmentStigSeverity["CAT_III"] = "CAT III";
})(CyberAssessmentStigSeverity || (CyberAssessmentStigSeverity = {}));
export const CYBER_ASSESSMENT_EVIDENCE_PACK_JURISDICTIONS = ['AU', 'US', 'UK'];
